import { NavbarMenu } from '@root/core/interfaces';

export const ADMIN_WAREHOUSE_MENU: NavbarMenu[] = [
  // example
  // {
  //   lable: "hhh",
  //   children: [
  //     { id: 1, name: "aa", url: "/admin/warehouse" },
  //     { id: 2, name: "bb", url: "#" },
  //     { id: 3, name: "dd", url: "#" },
  //   ],
  // },
  {
    id: 1,
    name: 'Dashboard',
    url: '/admin/warehouse'
  },
  { id: 2, name: 'Inquiry', url: '/admin/inquiry' },
  {
    id: 3,
    name: 'Inbound',
    url: '/admin/inbound'
  },
  {
    id: 4,
    label: 'Delivery',
    children: [
      {
        id: 10,
        name: 'Delivery List',
        url: '/admin/delivery'
      },
      {
        id: 11,
        name: 'Return List',
        url: '/admin/returnDelivery'
      }
    ]
  },
  {
    id: 5,
    name: 'Inventory',
    url: '/admin/inventory'
  },
  {
    id: 6,
    name: 'Retransfer/Disposal',
    url: '/admin/return'
  },
  {
    id: 7,
    label: 'Settlement',
    children: [
      {
        id: 8,
        name: 'Billing Inquiry',
        url: '/admin/billingInquiry'
      },
      {
        id: 9,
        name: 'Service Inquiry',
        url: '/admin/serviceInquiry'
      }
    ]
  }
];
